<template>
  <div v-if="item.deletedAt && item.deletedBy" class="deleted-info">File telah terhapus dari {{ formatDeletedAt(item.deletedAt) }}, oleh {{ item.deletedBy }}</div>
</template>

<script>
export default {
  props: { item: Object },
  methods: {
    formatDeletedAt(deletedAt) {
      if (Array.isArray(deletedAt)) {
        const [year, month, day] = deletedAt;
        return `${day.toString().padStart(2, "0")}-${month.toString().padStart(2, "0")}-${year}`;
      }

      if (typeof deletedAt === "string") {
        const date = new Date(deletedAt);
        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      }
      return "";
    },
  },
};
</script>
